import ky from 'ky';
import { TCustomer, TGeocodingResponse, TLocationCoordinate, TMenuCategory, TOrder, TRestaurant, TWorkingHours, TOrderFeedback } from '../types';
import Cookies from 'js-cookie'
import dayjs from 'dayjs';
import { isDevMode } from '../utils';
import { HTTPError } from 'ky';

const apiUrl = isDevMode() ? 'https://klikmenu.be/crocodile/staging/api' : 'https://klikmenu.be/crocodile/api';
//const apiUrl = 'http://127.0.0.1:8000'
const stagingRestaurantId = '5f688eb3a221501ad3bfdb33';
let cookieDomain: string | undefined

let apiClient = ky.create({ prefixUrl: `${apiUrl}/restaurants/${stagingRestaurantId}` })
let currentRestaurantId: string = '';
// let clientRefreshToken: string = ''; TODO: add session refresh

const initApi = async (domain?: string, locationId?: string, locale?: string) => {
    cookieDomain = domain;
    if (locationId) {
        const restaurant: TRestaurant = await ky.get(apiUrl + '/restaurants/locations/' + locationId).json()
        currentRestaurantId = restaurant._id
    } else {
        currentRestaurantId = stagingRestaurantId;
    }
    const authToken = Cookies.get('userData')
    apiClient = ky.create({
        prefixUrl: `${apiUrl}/restaurants/${currentRestaurantId}`,
        headers: {
            'Authorization': authToken ? `Bearer ${authToken}` : undefined,
            'Accept-Language': locale ? locale : undefined
        }
    })
    return currentRestaurantId;
}

const changeApiLocale = (locale: string) => {
    const authToken = Cookies.get('userData')
    apiClient = apiClient.extend({
        headers: {
            'Authorization': authToken ? `Bearer ${authToken}` : undefined,
            'Accept-Language': locale
        }
    })

    Cookies.set('userLocale', locale, { expires: dayjs().add(60, 'day').toDate(), domain: cookieDomain })
}

const getMenu = async (): Promise<TMenuCategory[]> => apiClient.get('menu').json()

const getRestaurantInfo = async (): Promise<TRestaurant> => apiClient.get('').json()

const getRestaurantReviews = async (): Promise<TOrderFeedback[]> => apiClient.get('feedback').json()

const getWorkingHoursForToday = async (): Promise<TWorkingHours> => apiClient.get('workingHoursForToday').json()

const requestConfirmationCode = async (name: string, phoneNumber: string) => {

    try {
        await apiClient.post('login', { json: { phoneNumber }, prefixUrl: apiUrl }).json();
    } catch (err) {
        const errorData: { status: string, message: string, id: string } = await (err as HTTPError).response.json();
        if (errorData.id === 'alexgrill.error.user.not.exists') {
            apiClient.post('register', { json: { name, phoneNumber }, prefixUrl: apiUrl }).json()
        }
    }
}
const checkConfirmationCode = async (phoneNumber: string, code: string) => {
    const { authToken }: { refreshToken: string, authToken: string } = await apiClient.post('confirm', { json: { phoneNumber, code }, prefixUrl: apiUrl }).json()
    apiClient = apiClient.extend({ headers: { 'Authorization': `Bearer ${authToken}` } })
    Cookies.set('userData', authToken, { expires: dayjs().add(60, 'day').toDate(), domain: cookieDomain })
    // clientRefreshToken = refreshToken;
}
const placeOrder = async (order: Partial<TOrder>, userId: string): Promise<TOrder> => apiClient.post('orders',
    { prefixUrl: apiUrl, json: { ...order, restaurant: currentRestaurantId, customer: userId, remindBeforehand: 15 } })
    .json()

const hideOrder = async (order: Partial<TOrder>): Promise<TOrder> => apiClient.patch(`orders/${order._id}`,
    { prefixUrl: apiUrl, json: { ...order, isHidden: true} })
    .json()

const getUserInfo = async (): Promise<TCustomer> => apiClient.get('me', { prefixUrl: apiUrl }).json()

const getCurrentOrder = async (): Promise<TOrder> => apiClient.get('me/orders/current', { prefixUrl: apiUrl }).json()

const postFeedback = async (rating: number, commentary: string, orderId: string, customerId: string): Promise<{ _id: string }> => apiClient.post(
    'feedback',
    {
        json: {
            customerFeedback: commentary,
            rating: rating,
            order: orderId,
            customer: customerId,
            restaurant: currentRestaurantId
        },
        prefixUrl: apiUrl
    })
    .json()

const getGeocoding = async (request: string, restaurantCoordinate: TLocationCoordinate): Promise<TGeocodingResponse[]> => apiClient.get(
    `orders/geocodeAddress?address=${request}&proximityLatitude=${restaurantCoordinate?.latitude}&proximityLongitude=${restaurantCoordinate?.longitude}`, { prefixUrl: apiUrl })
    .json()

const updateUserInfo = async (user: TCustomer): Promise<TCustomer> => apiClient.patch('me', { prefixUrl: apiUrl, json: user }).json()

const api = {
    initApi,
    changeApiLocale,
    getMenu,
    getRestaurantInfo,
    getRestaurantReviews,
    getWorkingHoursForToday,
    requestConfirmationCode,
    checkConfirmationCode,
    getUserInfo,
    placeOrder,
    hideOrder,
    postFeedback,
    getCurrentOrder,
    getGeocoding,
    updateUserInfo
};

export const getFixedImageUrl = (url: string) => `${apiUrl}${url}`

export default api;